
function cycleQuotes() {
  var body = document.querySelector('body');
  var quoteElements = document.querySelectorAll('.quote');
  var quoteNav = document.querySelectorAll('.quote_nav li');
  var currentQuoteIndex = 0;
  var intervalId;

  function cycle(q) {
    var currentQuote = quoteElements[currentQuoteIndex];
    var currentNav = quoteNav[currentQuoteIndex];

  //  var nextQuoteIndex = (currentQuoteIndex + 1) % quoteElements.length;
    //var nextQuoteNavIndex = (currentQuoteIndex + 1) % quoteNav.length;
 

	var nextQuoteIndex;
	if(q){
		nextQuoteIndex = q - 1;
	} else {
		nextQuoteIndex = (currentQuoteIndex + 1) % quoteElements.length;
	}
	var nextQuoteNavIndex;
	if(q){
		nextQuoteNavIndex = q - 1;
	} else {
		nextQuoteNavIndex = (currentQuoteIndex + 1) % quoteElements.length;
	}

	var nextQuote = quoteElements[nextQuoteIndex];
    var nextQuoteNav = quoteNav[nextQuoteIndex];

    // remove .current from the current quote
    currentQuote.classList.remove('current');
    currentNav.classList.remove('current');

    // add .current to the next quote
    nextQuote.classList.add('current');
    nextQuoteNav.classList.add('current');

    // update the current quote index
    currentQuoteIndex = nextQuoteIndex;
  }

  function startCycle(i) {
	var t = 7000;
	if(i){ t = 7000; }
    if (!intervalId) {
      currentQuoteIndex = 0;
      quoteElements[currentQuoteIndex].classList.add('current');
      quoteNav[currentQuoteIndex].classList.add('current');
      intervalId = setInterval(cycle, t);
    }
  }

  function stopCycle() {
    clearInterval(intervalId);
    intervalId = null;
    currentQuoteIndex = 0;
    quoteElements.forEach(function(quoteElement) {
      quoteElement.classList.remove('current');
    });
    quoteNav.forEach(function(quoteNav) {
      quoteNav.classList.remove('current');
    });
  }

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (body.classList.contains('quote-block-on')) {
          startCycle();
        } else {
          stopCycle('mutation evt');
        }
      }
    });
  });

  observer.observe(body, { attributes: true });
  $(".quote_nav li").click(function(){
	var q = $(this).data('q');
	stopCycle();          
	startCycle();

	cycle(q);
  });
}

cycleQuotes();